export default __webpack_public_path__ + "static/media/cookie2.10b6f545.svg";